/**
 * IntroVideoPage — trang riêng để đội nộp Video giới thiệu ở Vòng Sơ loại (R1).
 *
 * Tách khỏi MemorialsPage để rõ ràng theo Điều 9.3/9.4: video là phần nộp riêng,
 * không gộp với Đơn khởi kiện.
 *
 * Route: /intro-video (group "Bài nộp" trong sidebar).
 */
import {
  Alert,
  Box,
  Container,
  Typography,
} from '@mui/material'
import { Movie } from '@mui/icons-material'

import { useAppSelector } from '../hooks/redux'
import { useGetTeamsQuery } from '../store/api/teamsApi'
import { hasPermission } from '../utils/permissions'
import { PageHeader } from '../components/PageHeader'
import { R1IntroVideoUpload } from '../components/R1IntroVideoUpload'

export default function IntroVideoPage() {
  const { user: currentUser } = useAppSelector((state) => state.auth)
  const { data: teams = [], isLoading } = useGetTeamsQuery()

  const canSubmit = currentUser && hasPermission(currentUser.role, 'SUBMIT_MEMORIAL')
  const userTeam = teams.find((t) => t.members.includes(currentUser?.id || ''))

  return (
    <Container maxWidth="md" sx={{ mt: { xs: 2, sm: 3 }, mb: { xs: 2, sm: 4 }, px: { xs: 2, sm: 3 } }}>
      <PageHeader
        title="Video giới thiệu đội"
        subtitle="Vòng Sơ loại — nộp video clip 10 phút giới thiệu đội thi (Điều 9.3, dùng cho tie-break Điều 10.3)."
        icon={<Movie />}
      />

      {!canSubmit && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Chỉ thành viên đội thi mới được nộp video giới thiệu cho đội của mình.
        </Alert>
      )}

      {canSubmit && !isLoading && !userTeam && (
        <Alert severity="warning" sx={{ mb: 3 }}>
          Bạn chưa thuộc đội thi nào. Hãy hoàn tất đăng ký đội trước.
        </Alert>
      )}

      {canSubmit && userTeam && (
        <Box>
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>Yêu cầu:</strong> 1 video clip giới thiệu đội (≤ 10 phút, MP4/WebM/MOV, ≤ 200MB).
              Nội dung gồm: giới thiệu tên đội, thành viên, định hướng pháp lý chuyên môn,
              điểm mạnh đội thi.
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Áp dụng:</strong> Theo Điều 10.3 thể lệ — nếu Vòng Sơ loại có hai đội
              cùng tổng điểm, BTC sẽ chấm phụ video clip này (3 tiêu chí: sáng tạo,
              trình bày, chuyên nghiệp — mỗi tiêu chí 0–10đ) để phân hạng.
            </Typography>
          </Alert>
          <R1IntroVideoUpload team={userTeam} isOwnTeam />
        </Box>
      )}
    </Container>
  )
}
